export default "__VITE_ASSET__54cb2ff9__"